import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { awsConfig } from './config/aws-config';
import Dashboard from './pages/Dashboard';
import HuntList from './pages/HuntList';
import HuntForm from './pages/HuntForm';
import UserManagement from './pages/UserManagement';
import LocationSubmissions from './pages/LocationSubmissions';
import LocationManagement from './pages/LocationManagement';
import LocationAnalytics from './pages/LocationAnalytics';
import ModerationQueue from './pages/ModerationQueue';
import ModerationAnalytics from './pages/ModerationAnalytics';
import UserBehaviorAnalytics from './pages/UserBehaviorAnalytics';
import Layout from './components/Layout';
import '@aws-amplify/ui-react/styles.css';

// Configure Amplify
Amplify.configure(awsConfig);

const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32', // Green for food/foraging theme
    },
    secondary: {
      main: '#FF6F00', // Orange accent
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Authenticator>
        {({ signOut, user }) => (
          <Router>
            <Layout user={user} signOut={signOut}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/hunts" element={<HuntList />} />
                <Route path="/hunts/new" element={<HuntForm />} />
                <Route path="/hunts/:id/edit" element={<HuntForm />} />
                <Route path="/users" element={<UserManagement />} />
                <Route path="/locations/submissions" element={<LocationSubmissions />} />
                <Route path="/locations/management" element={<LocationManagement />} />
                <Route path="/locations/analytics" element={<LocationAnalytics />} />
                <Route path="/moderation/queue" element={<ModerationQueue />} />
                <Route path="/moderation/analytics" element={<ModerationAnalytics />} />
                <Route path="/moderation/user-behavior" element={<UserBehaviorAnalytics />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        )}
      </Authenticator>
    </ThemeProvider>
  );
}

export default App;
